import { Result } from "antd";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { ProtectedLayout, ProtectedRoute } from "./ProtectedRoutes";
import { HomeLayout, RolesLayout } from "./PublicRoutes";
import { roles } from "../config/roles";

import {
  ClientHome,
  ClientSettings,
  Membership,
  PaymentMethods,
  AddNewCard,
  EditCard,
  CreateEvent,
  Events,
  FindVendors,
  IndividulVendors,
  Personalization,
  EditEvent,
  EventDetail,
  InspirationalGallery,
  VendorDetails,
  EventsCalendar,
  SubContacts,
  SubContactDetails,
  AddNewTask,
  EditTask,
  YourVendorDetails,
  EventHistory,
  PaymentTracking,
  TrackingPayments,
  Guests,
  InspirationalGalleryDetails,
  CreateInspirationalGallery,
  IGImageDetails,
  EditInspirationalGallery,
  Gallery,
  GalleryDetails,
  UploadGallery,
  Inbox,
  CreateChatRoom,
  EditChatRoom,
  AddVendors,
  EditVendors,
  AddGuest,
  UploadImage,
  VenueImage,
  VendorPayment,
  LiveStream,
  CreateCountdown,
  EditCountdown,
  PrivateMsg,
  ChatRoom,
  Templates,
  Template,
  Countdown,
  CustomizeTemplate,
  Attendee,
  Rsvp,
  RsvpStory,
  RsvpTidbits,
  RsvpSchedule,
  RsvpAddress,
  QA,
  RequestedRsvp,
  RequestedRsvp2,
  Attendees,
  MyTemplateDetails,
  Addtemplate,
  SinglePlanningForm,
  SingleBudget,
  RsvpFamily,
  AddQuestions,
  GreetingTemplate,
  CustomizeGreetingTemplate,
  SelectedTemplate,
  VideoCall,
  SingleImage,
  EventVendors,
  ResponseReview,
  PlanningFormSection,
  WeddingWebsite,
  WeddingWallClient,
  GuestDetails,
  WeddingHighlightDetail,
  Pending,
  AttendeesDetails,
  RSVPDetails,
  RSVPPersonalized,
  RSVPTidbits,
  RSVPCelebrate,
  RSVPSend,
  RSVPGuest,
} from "../screens/ClientScreens";

import {
  ChangePassword,
  TermsAndConditions,
  PrivacyPolicy,
  AboutUs,
  InviteFriend,
  Profile,
  EditProfile,
  Contact,
  NewPassword,
  VerificationCode,
  ForgetPassword,
  Login,
  Signup,
  SelectRole,
  Notifications,
} from "../screens/CommonScreens";

import {
  RsvpIntro,
  RsvpGuestStory,
  RsvpDateTime,
  RsvpGuestTidbits,
  RsvpLive,
  GuestHome,
  GuestVideo,
  GuestChat,
  GuestEvents,
  RsvpQA,
  RsvpPeople,
  RsvpGuestSchedule,
  RsvpGuestAddress,
  RsvpGuestTable,
  RsvpGuestMeal,
  RsvpGuestWishing,
  RsvpGuestJoinLive,
  RsvpGuestInvitation,
  GuestWeddingWebsite,
  WeddingWallGuest,
  GuestRsvpCelebrate,
  GuestRsvpDetails,
  GuestFloorPlan,
  GuestRsvpTidbits,
  GuestRSVPAddMeal,
  GuestRsvpSubmit,
} from "../screens/GuestScreen";

import {
  Analytics,
  VendorHome,
  Advertisement,
  Reviews,
  VendorProfile,
  AddSubVendor,
  ProfileSubVendors,
  ProfileGallery,
  ProfileUploadPhoto,
  ProfileUploadDocument,
  VendorTemplates,
  BusinessInfo,
  EditBusinessInfo,
  TemplateDetail,
  VendorPlanningFormOne,
  VendorPlanningFormTwo,
  Reminder,
  EditAdds,
  EditSubVendor,
  SongIdeas,
  SpotifyDashboard,
  Callback
} from "../screens/VendorsScreens";
import SingleVideoCall from "../screens/ClientScreens/Inbox/VideoCall/SingleVideoCall";
import EventListGuest from "../screens/ClientScreens/Events/EventListGuest/EventListGuest";
import Permission from "../screens/ClientScreens/settings/Permission/Permission";
import MyTemplates from "../screens/VendorsScreens/VendorTemplates/MyTemplates/MyTemplates";
import Section from "../screens/VendorsScreens/VendorTemplates/Section/Section";
import GuestEventOverview from "../screens/GuestScreen/GuestEventOverview/GuestEventOverview";
import GuestList from "../screens/ClientScreens/GuestDetails/GuestList/GuestList";
import MusicList from "../screens/VendorsScreens/SongIdeas/MusicList/MusicList";
import PlanningForm from "../screens/VendorsScreens/TemplateDetail/PlanningForm/PlanningForm";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/selectrole" element={<SelectRole />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgotPassword" element={<ForgetPassword />} />
        <Route path="/verificationCode" element={<VerificationCode />} />
        <Route path="/enterNewPassword" element={<NewPassword />} />
      </Route>
      <Route element={<ProtectedLayout />}>
        {/* =================================================== coHost Screens & client  ======================================= */}
        <Route element={<RolesLayout roles={[roles.coHost, roles.client]} />}>
          {/* <Route path={"/events"} element={<Events />} /> */}
          <Route path={"/events/weddingWebsite"} element={<WeddingWebsite />} />
          <Route path={"/weddingWallClient"} element={<WeddingWallClient />} />
          <Route path={"/events/guestDetails"} element={<GuestDetails />} />
          <Route path={"/events/guestDetails/pending"} element={<Pending />} />
          <Route
            path={"/events/guestDetails/Attendees"}
            element={<AttendeesDetails />}
          />
          <Route path={"/events/RSVPDetails"} element={<RSVPDetails />} />
          <Route
            path={"/events/RSVPPersonalized"}
            element={<RSVPPersonalized />}
          />
          <Route path={"/events/RSVPTidbits"} element={<RSVPTidbits />} />
          <Route path={"/events/RSVPCelebrate"} element={<RSVPCelebrate />} />
          <Route path={"/events/RSVPSend"} element={<RSVPSend />} />
          <Route path={"/events/RSVPGuest"} element={<RSVPGuest />} />

          <Route
            path={"/events/inspirationalGallery"}
            element={<InspirationalGallery />}
          />
          <Route
            path={"/events/createInspirationalGallery"}
            element={<CreateInspirationalGallery />}
          />
          <Route
            path={"/events/editInspirationalGallery"}
            element={<EditInspirationalGallery />}
          />
          <Route path={"/events/editEvent"} element={<EditEvent />} />
          <Route
            path={"/events/budget/paymentTracking"}
            element={<PaymentTracking />}
          />
          <Route
            path={"/events/budget/paymentTracking/payments"}
            element={<TrackingPayments />}
          />
          <Route
            path={"/events/budget/paymentTracking/payments/vendor"}
            element={<VendorPayment />}
          />
          <Route path={"/events/eventDetail/guests"} element={<Guests />} />
          <Route
            path={"/events/eventDetail/guests/addGuest"}
            element={<AddGuest />}
          />
          <Route
            path={"/events/eventDetail/guests/uploadImage"}
            element={<UploadImage />}
          />
          <Route
            path={"/events/eventDetail/guests/venueImage"}
            element={<VenueImage />}
          />
          <Route
            path={"/events/GreetingTemplate"}
            element={<GreetingTemplate />}
          />
          <Route
            path={"/events/CustomizeGreetingTemplate"}
            element={<CustomizeGreetingTemplate />}
          />
          <Route
            path={"/events/SelectedTemplate"}
            element={<SelectedTemplate />}
          />
          {/*================= RSVP Screens ================= */}
          <Route path={"/events/rsvp"} element={<Rsvp />} />
          <Route path={"/events/rsvp/rsvpstory"} element={<RsvpStory />} />
          <Route path={"/events/rsvp/rsvptidbits"} element={<RsvpTidbits />} />
          <Route
            path={"/events/rsvp/rsvpschedule"}
            element={<RsvpSchedule />}
          />
          <Route path={"/events/rsvp/rsvpaddress"} element={<RsvpAddress />} />
          <Route path={"/events/rsvp/qa"} element={<QA />} />
          <Route
            path={"/events/rsvp/requestedrsvp"}
            element={<RequestedRsvp />}
          />
          <Route
            path={"/events/rsvp/requestedrsvp2"}
            element={<RequestedRsvp2 />}
          />
          <Route path={"/events/rsvp/rsvpfamily"} element={<RsvpFamily />} />
          <Route
            path={"/events/rsvp/addquestions"}
            element={<AddQuestions />}
          />
          {/*================= ATTENDEE Screens ================= */}
          <Route path={"/events/attendee"} element={<Attendee />} />
          <Route path={"/attendees"} element={<Attendees />} />

          <Route
            path={"/events/eventDetail/countdown"}
            element={<Countdown />}
          />
          <Route
            path={"/events/eventDetail/createCountdown"}
            element={<CreateCountdown />}
          />
          <Route
            path={"/events/eventDetail/editCountdown"}
            element={<EditCountdown />}
          />
          <Route
            path={"/events/eventDetail/planningForm"}
            element={<SinglePlanningForm />}
          />
          <Route
            path={"/events/eventDetail/section"}
            element={<PlanningFormSection />}
          />
          <Route
            path={"/events/eventDetail/singleBudget"}
            element={<SingleBudget />}
          />
        </Route>
        {/* =================================================== coHost, vendor & client Screens ======================================= */}
        <Route
          element={
            <RolesLayout
              roles={[roles.coHost, roles.client, roles.vendor, roles.staff]}
            />
          }
        >
          <Route path={"/events"} element={<Events />} />
          <Route path={"/events/eventDetail"} element={<EventDetail />} />
          <Route path={"/reminder"} element={<Reminder />} />
          <Route path={"/events/calendar"} element={<EventsCalendar />} />
          <Route
            path={"/events/eventDetail/addNewTask"}
            element={<AddNewTask />}
          />
          <Route path={"/events/eventDetail/editTask"} element={<EditTask />} />

          <Route path={"/findVendors/SubContacts"} element={<SubContacts />} />
          <Route
            path={"/findVendors/SubContactDetails"}
            element={<SubContactDetails />}
          />
          <Route path={"/findVendors"} element={<FindVendors />} />
          <Route
            path={"/findVendors/EventVendors"}
            element={<EventVendors />}
          />
          <Route
            path={"/findVendors/IndividulVendors"}
            element={<IndividulVendors />}
          />

          <Route
            path={"/findVendors/VendorDetails"}
            element={<VendorDetails />}
          />

          <Route
            path={"/findVendors/YourVendorDetails"}
            element={<YourVendorDetails />}
          />
          <Route
            path={"/events/inspirationalGalleryDetails"}
            element={<InspirationalGalleryDetails />}
          />
          {/* <Route path={"/events/igImageDetails"} element={<IGImageDetails />} /> */}
        </Route>
        {/*=================================================== giest client & cohost Screens ======================================= */}

        <Route
          element={
            <RolesLayout roles={[roles.guest, roles.client, roles.coHost]} />
          }
        >
          <Route path={"/events/gallery"} element={<Gallery />} />
          <Route path={"/events/galleryDetails"} element={<GalleryDetails />} />
          <Route
            path={"/events/WeddingHighlightDetails"}
            element={<WeddingHighlightDetail />}
          />
          <Route path={"/events/uploadGallery"} element={<UploadGallery />} />
          <Route path={"/events/singleImage"} element={<SingleImage />} />
        </Route>

        {/*=================================================== client Screens ======================================= */}
        <Route element={<RolesLayout roles={[roles.client]} />}>
          <Route path={"/reviewResponse"} element={<ResponseReview />} />
          <Route path={"/clientHome"} element={<ClientHome />} />
          <Route path={"/settings"} element={<ClientSettings />} />

          <Route
            path={"/settings/Personalization"}
            element={<Personalization />}
          />
          <Route path={"/createEvent"} element={<CreateEvent />} />

          {/* <Route path={"/events/calendar"} element={<Calendar />} /> */}
          {/* <Route
            path={"/events/createInspirationalGallery"}
            element={<CreateInspirationalGallery />}
          /> */}
          <Route path={"/privateMessage"} element={<PrivateMsg />} />
          <Route path={"/chatRoom"} element={<ChatRoom />} />

          {/*================= vendors Screens ================= */}

          {/* <Route path={"/findVendors"} element={<FindVendors />} />
          <Route
            path={"/findVendors/EventVendors"}
            element={<EventVendors />}
          />
          <Route
            path={"/findVendors/IndividulVendors"}
            element={<IndividulVendors />}
          />

          <Route
            path={"/findVendors/VendorDetails"}
            element={<VendorDetails />}
          />

          <Route
            path={"/findVendors/YourVendorDetails"}
            element={<YourVendorDetails />}
          /> */}

          <Route path={"/findVendors/AddVendors"} element={<AddVendors />} />
          <Route path={"/findVendors/EditVendors"} element={<EditVendors />} />

          {/*================= Templates Screens ================= */}

          <Route path={"/templates"} element={<Templates />} />
          <Route path={"/templates/template"} element={<Template />} />
          <Route
            path={"/templates/CustomizeTemplate"}
            element={<CustomizeTemplate />}
          />
          {/* <Route
            path={"/templates/CustomizeTemplate"}
            element={<CustomizeTemplate />}
          /> */}
          <Route
            path={"/templates/MyTemplateDetails"}
            element={<MyTemplateDetails />}
          />
          <Route path={"/templates/Addtemplate"} element={<Addtemplate />} />
        </Route>

        {/*=================================================== Guest Screens ======================================= */}

        <Route element={<RolesLayout roles={[roles.guest]} />}>
          <Route path={"/guestHome"} element={<GuestHome />} />
          <Route path={"/guestVideo"} element={<GuestVideo />} />
          <Route path={"/guestEvents"} element={<GuestEvents />} />
          <Route
            path={"/guestEventOverview"}
            element={<GuestEventOverview />}
          />
          <Route
            path={"/guestWeddingWebsite"}
            element={<GuestWeddingWebsite />}
          />
          <Route path={"/weddingWallGuest"} element={<WeddingWallGuest />} />
          <Route path={"/RsvpCelebrate"} element={<GuestRsvpCelebrate />} />
          <Route path={"/RsvpDetails"} element={<GuestRsvpDetails />} />
          <Route path={"/floorPlan"} element={<GuestFloorPlan />} />
          <Route path={"/RsvpTidbits"} element={<GuestRsvpTidbits />} />
          <Route path={"/RsvpAddMeal"} element={<GuestRSVPAddMeal />} />
          <Route path={"/RsvpSubmit"} element={<GuestRsvpSubmit />} />
        </Route>

        {/*=================================================== Vendors Screens ======================================= */}

        <Route element={<RolesLayout roles={[roles.vendor, roles.staff]} />}>
          <Route path={"/vendorHome"} element={<VendorHome />} />
          <Route path={"/analytics"} element={<Analytics />} />
          <Route path={"/Advertisement"} element={<Advertisement />} />
          <Route
            path={"/Advertisement/EditAddvertisement"}
            element={<EditAdds />}
          />

          <Route path={"/addSubVendor"} element={<AddSubVendor />} />
          <Route path={"/editSubVendor"} element={<EditSubVendor />} />
          <Route path={"/profile/VendorProfile"} element={<VendorProfile />} />
          <Route path={"/profile/subVendors"} element={<ProfileSubVendors />} />
          <Route path={"/profile/gallery"} element={<ProfileGallery />} />
          <Route
            path={"/profile/gallery/uploadPhoto"}
            element={<ProfileUploadPhoto />}
          />
          <Route
            path={"/profile/gallery/uploadDocument"}
            element={<ProfileUploadDocument />}
          />
          <Route
            path={"/events/eventDetail/templates/vendor"}
            element={<VendorTemplates />}
          />
          <Route
            path={"/events/eventDetail/templates/section"}
            element={<Section />}
          />
          <Route path={"/templates/mytemplates"} element={<MyTemplates />} />
          <Route path={"/templates/section"} element={<Section />} />
          <Route
            path={"/events/eventDetail/templates/vendor/templateDetail"}
            element={<TemplateDetail />}
          />

          <Route
            path={"/templates/vendor/templateDetail"}
            element={<TemplateDetail />}
          />
          <Route
            path={"/templates/vendor/templateDetail/planningForm"}
            element={<PlanningForm />}
          />
          <Route path={"/templates/vendor"} element={<VendorTemplates />} />

          {/* <Route path={"/profile/VendorProfile"} element={<VendorProfile />} /> */}
          <Route path={"/profile/BusinessInfo"} element={<BusinessInfo />} />
          <Route
            path={"/editProfile/EditBusinessInfo"}
            element={<EditBusinessInfo />}
          />
          <Route
            path={"/events/eventDetail/templateDetail/planningForm/1"}
            element={<VendorPlanningFormOne />}
          />
          <Route
            path={"/templateDetail/planningForm/2"}
            element={<VendorPlanningFormTwo />}
          />
          <Route
            path={"/songIdeas"}
            element={<SongIdeas />}
          />
          <Route
            path={"/songIdeas/MusicList"}
            element={<MusicList />}
          />
          <Route
            path={"/songIdeas/MusicList/SpotifyDashboard"}
            element={<SpotifyDashboard />}
          />
          {/* <Route
            path={"/callback"}
            element={<Callback />}
          /> */}
          {/* <Route path={"/findVendors"} element={<FindVendors />} />
          <Route
            path={"/Vendors"}
            element={<EventVendors />}
          /> */}
        </Route>
        {/* <Route
            path={"/findVendors/IndividulVendors"}
            element={<IndividulVendors />}
          /> */}

        {/* <Route
            path={"/findVendors/VendorDetails"}
            element={<VendorDetails />}  
          /> */}

        {/*=================================================== common Screens ======================================= */}
        {/*=================================================== vendor & Client Common Screens ======================================= */}
        <Route
          element={
            <RolesLayout roles={[roles.vendor, roles.client, roles.staff]} />
          }
        >
          <Route path={"/reviews"} element={<Reviews />} />
          <Route
            path={"/callback"}
            element={<Callback />}
          />
        </Route>

        {/*=================================================== Guest & Client Common Screens ======================================= */}
        <Route
          element={
            <RolesLayout roles={[roles.guest, roles.client, roles.coHost]} />
          }
        >
          <Route
            path={"/events/eventDetail/liveStream"}
            element={<LiveStream />}
          />
        </Route>
        <Route
          element={
            <RolesLayout roles={[roles.client, roles.vendor, roles.guest]} />
          }
        >
          <Route path={"/membership"} element={<Membership />} />
          <Route path={"/paymentMethods"} element={<PaymentMethods />} />
          <Route path={"/addNewCard"} element={<AddNewCard />} />
          <Route path={"/editCard"} element={<EditCard />} />

          <Route path={"/createChatroom"} element={<CreateChatRoom />} />
          <Route path={"/editChatroom"} element={<EditChatRoom />} />
        </Route>

        <Route path={"/inbox"} element={<Inbox />} />
        <Route path={"/profile"} element={<Profile />} />
        <Route path={"/editProfile"} element={<EditProfile />} />
        <Route path={"/settings/ChangePassword"} element={<ChangePassword />} />
        <Route path={"/settings/events"} element={<EventListGuest />} />
        <Route path={"/permission"} element={<Permission />} />
        <Route path={"/notifications"} element={<Notifications />} />
        <Route path={"/contactUs"} element={<Contact />} />
        <Route path={"/termsAndConditions"} element={<TermsAndConditions />} />
        <Route path={"/privacyPolicy"} element={<PrivacyPolicy />} />
        <Route path={"/aboutUs"} element={<AboutUs />} />
        <Route path={"/inviteFriend"} element={<InviteFriend />} />
        <Route path={"/events/eventHistory"} element={<EventHistory />} />
        <Route path={"/videoCall"} element={<VideoCall />} />
        <Route path={"/singleVideoCall"} element={<SingleVideoCall />} />
      </Route>

      {/*=================================================== client Screens without side menu ======================================= */}
      <Route element={<ProtectedRoute />}>
        <Route element={<RolesLayout roles={[roles.guest]} />}>
          {/*=================================================== RSVP Screens client======================================= */}

          <Route path={"/rsvp/rsvpIntro"} element={<RsvpIntro />} />
          <Route path={"/rsvp/rsvpDateTime"} element={<RsvpDateTime />} />
          <Route path={"/rsvp/rsvpGuestStory"} element={<RsvpGuestStory />} />
          <Route
            path={"/rsvp/rsvpGuestTidbits"}
            element={<RsvpGuestTidbits />}
          />
          <Route path={"/rsvp/rsvpQA"} element={<RsvpQA />} />
          <Route path={"/rsvp/rsvpPeople"} element={<RsvpPeople />} />
          <Route
            path={"/rsvp/rsvpGuestSchedule"}
            element={<RsvpGuestSchedule />}
          />
          <Route
            path={"/rsvp/rsvpGuestAddress"}
            element={<RsvpGuestAddress />}
          />
          <Route path={"/rsvp/rsvpGuestTable"} element={<RsvpGuestTable />} />
          <Route path={"/rsvp/rsvpGuestMeal"} element={<RsvpGuestMeal />} />
          <Route
            path={"/rsvp/rsvpGuestInvitation"}
            element={<RsvpGuestInvitation />}
          />
          <Route
            path={"/rsvp/rsvpGuestWishing"}
            element={<RsvpGuestWishing />}
          />
          <Route
            path={"/rsvp/rsvpGuestJoinLive"}
            element={<RsvpGuestJoinLive />}
          />
          <Route path={"/rsvp/rsvplive"} element={<RsvpLive />} />
        </Route>
      </Route>

      {/* </Route> */}
      <Route
        path="*"
        element={
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            // extra={<Button type="primary">Back Home</Button>}
          />
        }
      />
    </>
  )
);
